/*
 *  TTTech nerve-management-system-frontend
 *  Copyright(c) 2026. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */

import BaseApiService from './base.api-service';

const ENDPOINT = '/nerve/ms-configuration';

/**
 * @description This service is used to fetch configuration sections from the MS Configuration API.
 */
class MsConfigurationApiService extends BaseApiService {
  getConfigurationSection(sections, options = {}) {
    const requestOptions = {
      authRequired: options.authRequired ?? true,
      ignoreInterceptor: true,
    };

    if (sections) {
      requestOptions.params = { section: sections.join(',') };
    }

    return this.get(ENDPOINT, requestOptions);
  }
}

export default new MsConfigurationApiService();
